import { visit } from 'unist-util-visit';
import { Plugin } from 'unified';
import { Node } from 'unist';

/** Our custom details node type. */
interface DetailsNode extends Node {
  type: 'details';
  summary: string;
  children: Node[];
}

/**
 * This plugin expects you to write Markdown like:
 *
 * :::details "My Summary"
 * Here is some text.
 * :::
 *
 * If you're using remarkDirective, that becomes a node of type "containerDirective"
 * with node.name === "details".
 */
export const remarkDetails: Plugin = () => {
  return (tree) => {
    visit(tree as any, (node, index, parent) => {
      if (node.type === 'containerDirective' && (node as any).name === 'details') {
        // cast to be able to access .children
        const container = node as any;
        const children = container.children || [];

        let summary = '';
        // if the first child is a paragraph, treat it as a summary
        if (children.length > 0 && children[0].type === 'paragraph') {
          const firstParagraph = children[0];
          // gather its text
          summary = firstParagraph.children
            ?.map((c: any) => c.value ?? '')
            .join(' ')
            .trim();
          // remove that from the children array
          children.shift();
        }

        const detailsNode: DetailsNode = {
          type: 'details',
          summary,
          children
        };

        if (parent && typeof index === 'number') {
          parent.children[index] = detailsNode;
        }
      }
    });
  };
};